import storage from 'storejs';
import userAPI from '../../api/userAPI';
import {
    getUid
} from '../../api/getUserInfo';

export default {
    namespaced: true,
    state: {
        userInfo: {}, // 用户信息  A:代表 B：code用户
        encrypt: '', // 登录态
        realName: {}, // 实名认证图片
        inviteUid: '',
        uidStatus: true, // 调用发消息接口状态
    },
    getters: {
        // 用户信息
        userInfo(state) {
            return state.userInfo
        },
        // 登录态
        encrypt(state) {
            return state.encrypt
        },
        // 实名认证图片
        realName(state) {
            return state.realName
        },
        // 邀请码
        inviteUid(state) {
            return state.inviteUid;
        },
        uidStatus(state) {
            return state.uidStatus;
        },
    },
    mutations: {
        _loadUserInfo(state) {
            //  读取localStorage信息
            let storageMy = storage(process.env.STORAGE_NAME) || {};
            console.log('localStorage信息', storageMy);
            if (storageMy) {
                state.encrypt = storageMy.encrypt || '';
                state.userInfo = storageMy.userInfo || null; // 邀请码信息
                state.inviteUid = storageMy.inviteUid || null;
            }
        },
        // 设置encrypt
        _setEncrypt(state, encrypt) {
            state.encrypt = '';
            state.encrypt = encrypt;
        },
        // 设置用户信息
        _setUserInfo(state, userInfo) {
            state.userInfo = {};
            state.userInfo.userName = userInfo.userName;
            state.userInfo.userId = userInfo.userId;
            state.userInfo.userType = userInfo.userType;
            state.userInfo.type = userInfo.type;
            state.userInfo.mobile = userInfo.mobile;
            state.userInfo.realnameAuthStatus = userInfo.realnameAuthStatus;
            state.userInfo.hospitalName = userInfo.hospitalName;
            state.userInfo.departmentName = userInfo.departmentName;
            state.userInfo.departmentCode = userInfo.departmentCode;
            state.userInfo.positionName = userInfo.positionName;
            state.userInfo.positionCode = userInfo.positionCode;
            state.userInfo.email = userInfo.email;
            state.userInfo.yxjUserId = userInfo.yxjUserId;
            state.userInfo.healthCarePersonalUrl = userInfo.healthCarePersonalUrl;
            state.userInfo.healthCarePhotoUrl = userInfo.healthCarePhotoUrl;
            state.userInfo.idCardUrl = userInfo.idCardUrl;
            state.userInfo.badgePhotoUrl = userInfo.badgePhotoUrl;
            state.userInfo.portraitUrl = userInfo.portraitUrl;
            console.log('_setUserInfo', state.userInfo)
        },
        // 设置实名认证状态
        setRealName(state, realName) {
            state.realName = {};
            state.realName.healthCarePersonalUrl = realName.healthCarePersonalUrl;
            state.realName.healthCarePhotoUrl = realName.healthCarePhotoUrl;
            state.realName.idCardUrl = realName.idCardUrl;
            state.realName.badgePhotoUrl = realName.badgePhotoUrl;
        },

        setinviteUid(state, inviteUid) {
            //  读取storage
            let storageSTYY = storage(process.env.STORAGE_NAME);
            if (!storageSTYY) { //该用户没登录==》去登陆完善信息==》上报关联信息
                storageSTYY = {};
            }
            storageSTYY.inviteUid = inviteUid;
            storage({
                [process.env.STORAGE_NAME]: storageSTYY
            });
            state.inviteUid = inviteUid;
        },
    },
    actions: {
        async init({
            commit,
            dispatch,
            state
        }) {
            // 医生站进入
            // 如果query中存在tempJSInteractionFlag的场合，为医生站app免登录
            if (location.href.indexOf('tempJSInteractionFlag') >= 0) {
                console.log('医生站登录');
                let uid = null;
                try {
                    uid = await getUid();
                    const userInfo = state.userInfo;
                    const yszUid = userInfo && userInfo.yxjUserId ? userInfo.yxjUserId : '';
                    const encrypt = state.encrypt;
                    if (uid && uid !== -1) {
                        if ((yszUid.toString() !== uid.toString()) || !encrypt) {
                            await dispatch('login', {
                                yxjUserId: uid,
                                regSource: 6,
                            });
                            commit('setInited', null, {
                                root: true
                            });
                        }
                        return;
                    }
                } catch (error) {
                    console.log('app登录错误');
                }
                return;
            }
            // 加载用户信息
            commit('_loadUserInfo');
        },
        //设置邀请状态
        setUidStatus({ state }, status) {
            state.uidStatus = status;
        },

        // 保存encrypt
        saveEncrypt({
            commit
        }, encrypt) {
            console.log('父类调用保存encrypt');
            let storageMy = storage(process.env.STORAGE_NAME) || {};
            storageMy.encrypt = encrypt
            storage.set(process.env.STORAGE_NAME, storageMy);
            commit('_setEncrypt', encrypt);
        },
        // 保存用户信息
        save({
            commit
        }, userInfo) {
            console.log('父类调用保存userInfo');
            //  读取storage
            let storageMy = storage(process.env.STORAGE_NAME) || {};
            let myUserInfo = {};
            myUserInfo.userName = userInfo.userName;
            myUserInfo.userId = userInfo.userId;
            myUserInfo.userType = userInfo.userType;
            myUserInfo.type = userInfo.type;
            myUserInfo.mobile = userInfo.mobile;
            myUserInfo.realnameAuthStatus = userInfo.realnameAuthStatus;
            myUserInfo.hospitalName = userInfo.hospitalName;
            myUserInfo.departmentName = userInfo.departmentName;
            myUserInfo.departmentCode = userInfo.departmentCode;
            myUserInfo.positionName = userInfo.positionName;
            myUserInfo.positionCode = userInfo.positionCode;
            myUserInfo.email = userInfo.email;
            myUserInfo.yxjUserId = userInfo.yxjUserId;
            myUserInfo.healthCarePersonalUrl = userInfo.healthCarePersonalUrl;
            myUserInfo.healthCarePhotoUrl = userInfo.healthCarePhotoUrl;
            myUserInfo.idCardUrl = userInfo.idCardUrl;
            myUserInfo.badgePhotoUrl = userInfo.badgePhotoUrl;
            storageMy.userInfo = myUserInfo;
            storage.set(process.env.STORAGE_NAME, storageMy);
            console.log('userInfo', userInfo)
            commit('_setUserInfo', userInfo);
            commit('setRealName', {})
        },

        /** 用户注册登录
         * @param {Object} params-请求参数
         * @param {String} params.mobile-手机号
         * @param {String} params.smsCode-验证码
         */
        async login({
            dispatch
        }, params) {
            try {
                let data = await userAPI.login(params);
                if (data.code === 1) {
                    const encrypt = data.encrypt;
                    const userInfo = data.data;
                    dispatch('saveEncrypt', encrypt);
                    dispatch('save', userInfo);
                }
                return data
            } catch (error) {
                throw error;
            }
        },
        // 获取用户信息
        async getUserInfo({
            dispatch
        }, params) {
            try {
                let userInfo = await userAPI.getUserInfo(params);
                dispatch('save', userInfo.data);
                return userInfo.data
            } catch (error) {
                console.log('用户信息保存失败')
                throw error;
            }
        },
        // 获取验证码
        /**
         * @param {Object} params-请求参数
         * @param {String} params.mobile-手机号
         */
        async getVcode(context, params) {
            try {
                await userAPI.getVcode(params);
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },
        // 保存用户基本信息
        async saveUserBaseInfo({
            dispatch
        }, params) {
            try {
                await userAPI.saveUserBaseInfo(params);
            } catch (error) {
                console.log('用户信息保存失败')
                throw error;
            }
        },
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/user.js